import { 
  SMSearchFormData, 
  SMSearchFormValidationData, 
  SMSearchFormWarningsData 
} from '../../../integrated-client/models';

export interface IRuleItemEditFormData {
  data?: SMSearchFormData
  validation?: SMSearchFormValidationData
  warnings?: SMSearchFormWarningsData
  readyToFetchWarningsBeforeSave: boolean
}

export class RuleItemEditFormData implements IRuleItemEditFormData {

  data?: SMSearchFormData
  validation?: SMSearchFormValidationData
  warnings?: SMSearchFormWarningsData
  readyToFetchWarningsBeforeSave: boolean

  constructor() {
    this.readyToFetchWarningsBeforeSave = false;
  }

}